import { Fragment } from "react";

import useAccountManagementSecurityRolesEdit from "./UseAccountManagementSecurityRolesEdit";

import SecurityRolesForm from "../components/forms/SecurityRolesForm";

import Headings from "@usas/ui-web/components/headings/Headings";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";

import Constants from "@usas/ui-web/utils/Constants";

const AccountManagementSecurityRolesEdit = () => {
  const {
    isSaving,
    securityRoleData,
    onSubmitFormCallback,
    onBackClicked
  } = useAccountManagementSecurityRolesEdit();

  return (
    <Fragment>
      <div className='row usas-extra-top-margin'>
        <div className='col-xs-12'>
          <Headings.H3>Edit Security Role</Headings.H3>
        </div>
      </div>
      <SecurityRolesForm
        securityRoleData={securityRoleData}
        onSubmitFormCallback={onSubmitFormCallback}
        onSecondaryButtonClicked={onBackClicked} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  );
};

export default AccountManagementSecurityRolesEdit;